import React from "react";
import { motion } from "framer-motion";
import SocialMedia from "../Components/SocialMedia";

function About() {
    return (
        <div id="about" className="h-full !pt-12">
            <motion.div
                whileInView={{ y: [50, 0], opacity: [0, 1] }}
                transition={{ duration: 1, ease: "easeInOut" }}
                className="p-3 md:p-10 w-full text-center">
                <center>
                    <div className="w-fit font-mono font-extrabold text-transparent text-4xl md:text-5xl bg-clip-text bg-gradient-to-r from-[#8E2DE2] to-[#510bde]">
                        About Me
                    </div>

                    <br />
                    <p className="lg:w-4/5  font-mono">
                        Hi, my name is{" "}
                        <b className="!font-extrabold text-red-500">
                            Shubhankar Nautiyal
                        </b>{" "}
                        and I am a Passionate Software Developer specializing in React, Next.js, and React Native, with a strong focus on building high-performance, user-friendly web and mobile applications. Experienced in crafting scalable frontend solutions, optimizing performance, and contributing to open-source projects. Always eager to collaborate and innovate in the tech space.

                    </p>
                    <br />

                    <div className="text-2xl font-mono  font-bold">
                        Contact -
                        <SocialMedia isContact={true} />
                    </div>
                </center>
            </motion.div>
        </div>
    );
}

export default About;
